import { GRECAPTCHA_SITE_KEY } from "./constants";

const siteKey = process.env.RECAPTCHA_SITE_KEY || GRECAPTCHA_SITE_KEY;

export function isRecaptchaConfigured() {
  return Boolean(siteKey);
}

function waitForGrecaptcha(timeoutMs = 5000, intervalMs = 50) {
  return new Promise((resolve, reject) => {
    const start = Date.now();
    const timer = setInterval(() => {
      if (typeof window !== 'undefined' && window.grecaptcha) {
        clearInterval(timer);
        resolve(window.grecaptcha);
      } else if (Date.now() - start > timeoutMs) {
        clearInterval(timer);
        reject(new Error('reCAPTCHA not loaded'));
      }
    }, intervalMs);
  });
}

export async function grecaptchaReady() {
  const grecaptcha = await waitForGrecaptcha();
  return new Promise((resolve) => grecaptcha.enterprise.ready(() => resolve()));
}

export async function getRecaptchaToken() {
  if (!isRecaptchaConfigured()) return null;
  await grecaptchaReady();
  return window.grecaptcha.enterprise.execute(siteKey, {
    action: 'contact_us_submit',
  });
}
